import { Loader2 } from "lucide-react";
import { useEffect, useState } from "react";

interface RefreshIndicatorProps {
  active: boolean;
  delayMs?: number;
}

// Subtle "Refreshing…" pip for stale-while-revalidate refetches.
// Stays invisible for the first delayMs of activity so quick refetches
// (the common case) don't add visual noise.
export function RefreshIndicator({ active, delayMs = 300 }: RefreshIndicatorProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!active) {
      setVisible(false);
      return;
    }
    const timeout = setTimeout(() => setVisible(true), delayMs);
    return () => clearTimeout(timeout);
  }, [active, delayMs]);

  return (
    <span
      role="status"
      aria-live="polite"
      aria-label={visible ? "Refreshing" : undefined}
      className="inline-flex min-w-[5.5rem] items-center gap-1 text-xs text-text-faint"
    >
      {visible && (
        <>
          <Loader2 size={12} className="animate-spin" />
          <span>Refreshing…</span>
        </>
      )}
    </span>
  );
}
